import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { validateEnv, DEBUG } from './services/supabase/env'

// Validate environment variables before starting the app
if (!validateEnv()) {
  console.error('Application startup failed due to missing environment variables.')
  // In a real app, you might want to render an error screen instead
}

// Enable React profiling in debug mode
if (DEBUG) {
  console.log('Debug mode enabled')
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
